import { useQuery } from '@tanstack/react-query';
import { pcmpStatusCatalogQueryOptions } from '../api/pcmpStatus.api';

/**
 * The Not Verified reason of a link, checked against the reasons the API
 * lists: it refuses any other code, so a stale or hand-edited link is dropped
 * rather than sent. `isReady` is false until a reason can be checked.
 */
export function usePcmpMisStatusSubStatus(raw: string | undefined) {
  const { data: catalog } = useQuery(pcmpStatusCatalogQueryOptions());

  if (raw === undefined) return { subStatus: undefined, isReady: true };
  if (!catalog) return { subStatus: undefined, isReady: false };
  const isKnown = catalog.misReasons.some((reason) => reason.code === raw);
  return { subStatus: isKnown ? raw : undefined, isReady: true };
}
